/* Pure functions shared by the storefront integration and its tests. */
(function (root) {
  'use strict';
  const api = {
    remainingUpdates(cart, purchased) {
      const remaining = new Map(purchased.map(x => [String(x.variant_id), x.quantity]));
      const updates = {};
      for (const item of cart.items) {
        // Personalized/subscription lines were not bought by this release.
        if (item.selling_plan_allocation || Object.keys(item.properties || {}).length) continue;
        const id = String(item.variant_id);
        const remove = Math.min(item.quantity, remaining.get(id) || 0);
        if (remove) { updates[item.key] = item.quantity - remove; remaining.set(id, remaining.get(id) - remove); }
      }
      return updates;
    },
    assertCart(cart) {
      if (cart.currency !== 'USD') throw new Error('This checkout supports USD only.');
      if (!cart.items?.length) throw new Error('Your cart is empty.');
      if (cart.total_discount > 0 || cart.items.some(x => x.final_price !== x.original_price)) {
        throw new Error('This checkout does not support discounted carts yet. Please contact the store.');
      }
      for (const item of cart.items) {
        if (item.selling_plan_allocation || Object.keys(item.properties || {}).length) {
          throw new Error('Subscriptions and personalized items are not supported by this checkout yet.');
        }
      }
    }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.SCBUtils = api;
})(typeof window === 'undefined' ? globalThis : window);
